var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotRecorded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5003 2.33594H7.00033C6.38149 2.33594 5.78799 2.58177 5.35041 3.01935C4.91282 3.45694 4.66699 4.05043 4.66699 4.66927V23.3359C4.66699 23.9548 4.91282 24.5483 5.35041 24.9859C5.78799 25.4234 6.38149 25.6693 7.00033 25.6693H21.0003C21.6192 25.6693 22.2127 25.4234 22.6502 24.9859C23.0878 24.5483 23.3337 23.9548 23.3337 23.3359V8.16927L17.5003 2.33594Z",
    stroke: "#595959",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.333 2.33594V7.0026C16.333 7.62144 16.5788 8.21494 17.0164 8.65252C17.454 9.0901 18.0475 9.33594 18.6663 9.33594H23.333",
    stroke: "#595959",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9163 14.5859L11.083 20.4193",
    stroke: "#595959",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.083 14.5859L16.9163 20.4193",
    stroke: "#595959",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotRecorded);
export default __webpack_public_path__ + "static/media/NotRecorded.f532c73733397ffdbd477b0252489015.svg";
export { ForwardRef as ReactComponent };